var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[_c('div',[_vm._v(" Created ")]),_c('div',[_c('div',[_vm._v(" ASD asdasd ")]),_c('div',[_vm._v(" Asdff fdfdf ")]),_c('div',[_vm._v(" Asdff fdfdffdfdwe ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }